import styles from './Dialog.module.css'

const DesktopDialogWrapper = ({ data, children, withOverlay = true }) => {
  const backgroundImageUrl = data?.backgroundImageUrl
  const logoUrl = data?.logoUrl

  return (<>
  {withOverlay && <div className={styles.desktopOverlay}></div>}
    <div className={[styles.desktopDialog, withOverlay ? styles.desktopDialogWithOverlay : {}].join(' ')}> 
      <div className={styles.desktopGraphicHolder} style={{ backgroundImage: `url(${backgroundImageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
        <img className={styles.desktopLogo} src={logoUrl} alt="logo" />
        <div className={styles.desktopGraphicOverlay}></div>
      </div>   
      <div className={styles.desktopContentHolder}>
        <div className={styles.desktopContentHolderInner}>
          {children}
        </div>
      </div>
    </div>
  </>)
}

export default DesktopDialogWrapper